export const getAnswersData = function (key) {
  return store.getAnswers().data ? store.getAnswers().data[key] : '';
};
